"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// CORE
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const prop_types_1 = __importDefault(require("prop-types"));
const react_use_1 = require("react-use");
const immutable_1 = require("immutable");
// MUI
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const List_1 = __importDefault(require("@mui/material/List"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const mui_1 = require("tss-react/mui");
const DialogContent_1 = __importDefault(require("@mui/material/DialogContent"));
const TextField_1 = __importDefault(require("@mui/material/TextField"));
const DialogActions_1 = __importDefault(require("@mui/material/DialogActions"));
// MUI ICONS
const CancelPresentation_1 = __importDefault(require("@mui/icons-material/CancelPresentation"));
const Delete_1 = __importDefault(require("@mui/icons-material/Delete"));
const MoreVert_1 = __importDefault(require("@mui/icons-material/MoreVert"));
const Refresh_1 = __importDefault(require("@mui/icons-material/Refresh"));
const Explore_1 = __importDefault(require("@mui/icons-material/Explore"));
const ExploreOff_1 = __importDefault(require("@mui/icons-material/ExploreOff"));
const FindReplace_1 = __importDefault(require("@mui/icons-material/FindReplace"));
const core_1 = require("companion-app-components/utils/core");
const root_ui_1 = require("companion-app-components/flux/root-ui");
const feature_flags_1 = require("companion-app-components/flux/feature-flags");
// DATA
const accounts_svg_1 = __importDefault(require("assets/nav-menu/accounts.svg"));
const actions_1 = require("data/AccountDiscovery/actions");
const selectors_1 = require("data/aggErrors/selectors");
const actions_2 = require("data/institutionLogins/actions");
const selectors_2 = require("data/institutionLogins/selectors");
const types_1 = require("data/institutionLogins/types");
const utils_1 = require("data/institutionLogins/utils");
const selectors_3 = require("data/datasetSharing/selectors");
// UTILS
const actionHelpers_1 = require("utils/actionHelpers");
// LOCAL
const RendersCount_1 = __importDefault(require("components/RendersCount"));
const QButton_1 = __importStar(require("components/QButton"));
const StdDialog_1 = __importDefault(require("components/Dialogs/StdDialog"));
const AccountListItem_1 = __importDefault(require("components/AccountCard/AccountListItem"));
const Dump_1 = __importDefault(require("components/Dump"));
const NestedQMenu_1 = __importDefault(require("components/NestedQMenu"));
const ConfirmationDialog_1 = require("components/Dialogs/ConfirmationDialog");
const selectors_4 = require("./selectors");
const styles_1 = __importDefault(require("./styles"));
const useStyles = (0, mui_1.makeStyles)()(styles_1.default);
const AccountCardHook = (props) => {
    const { institutionLogin, id, branding, title, accounts, isWebFirstDataset } = props;
    const dispatch = (0, react_redux_1.useDispatch)();
    const { classes, cx, theme } = useStyles();
    // ====================================== Component State ================================================ //
    const [menuAnchorEl, setMenuAnchorEl] = (0, react_1.useState)(null);
    const [showExpandedMenu, setShowExpandedMenu] = (0, react_1.useState)(false);
    const [updatedInstitutionName, setUpdatedInstitutionName] = (0, react_1.useState)(null);
    const [showEditDialog, toggleShowEditDialog] = (0, react_use_1.useToggle)(false);
    // ====================================== Redux Selectors ================================================ //
    const aggLoading = !(0, react_redux_1.useSelector)((state) => (0, selectors_2.getIdsRefreshing)(state)).isEmpty();
    const aggAction = (0, react_redux_1.useSelector)((state) => (0, selectors_1.getAggregationAction)(state, props));
    const featureFlags = (0, react_redux_1.useSelector)((state) => feature_flags_1.featureFlagsSelectors.getFeatureFlags(state));
    const isCurrentDatasetOwner = (0, react_redux_1.useSelector)((state) => (0, selectors_3.getIsCurrentDatasetOwner)(state));
    const loginHasConnnectedAccountsProps = (0, react_1.useMemo)(() => ({ institutionLoginId: (institutionLogin === null || institutionLogin === void 0 ? void 0 : institutionLogin.id) || null }), [institutionLogin]);
    const loginHasConnectedAccounts = (0, react_redux_1.useSelector)((state) => (0, selectors_4.hasConnectedAccounts)(state, loginHasConnnectedAccountsProps));
    // ====================================== Callbacks ================================================ //
    const handleOpenMenu = (0, react_1.useCallback)((e) => {
        setMenuAnchorEl(e.currentTarget);
        if (e.shiftKey)
            setShowExpandedMenu(true);
    }, []);
    const handleCloseMenu = (0, react_1.useCallback)(() => {
        setMenuAnchorEl(null);
        setShowExpandedMenu(false);
    }, []);
    const handleUpdateInstitutionName = (0, react_1.useCallback)(() => {
        toggleShowEditDialog();
        const institutionLoginToUpdate = institutionLogin ? (0, types_1.mkInstitutionLogin)({
            id: institutionLogin.id,
            institutionId: institutionLogin.institutionId,
            name: updatedInstitutionName,
        })
            :
                null;
        dispatch((0, actions_2.updateInstitutionLogin)(institutionLoginToUpdate));
        const { institution } = institutionLogin;
        core_1.tracker.track(core_1.tracker.events.fiLoginNameSave, { institution_id: institution ? institution.id : '0' });
    }, [institutionLogin, dispatch, updatedInstitutionName, toggleShowEditDialog]);
    // ====================================== Dialog Kickoffs ================================================ //
    const kickoffResetFi = (0, react_1.useCallback)(() => {
        handleCloseMenu();
        dispatch(root_ui_1.rootUiActions.createDialog(root_ui_1.rootUiTypes.mkRootUiData({
            id: 'reset-login-connection',
            type: ConfirmationDialog_1.DIALOG_TYPE,
            allowNesting: true,
            props: (0, immutable_1.Map)((0, ConfirmationDialog_1.mkConfirmationDialogProps)({
                title: 'Reset connection',
                content: `Resetting your connection will disconnect ${institutionLogin.name} from Quicken and prompt you to reconnect it. If restoring connectivity is not successful the institution will remain in Quicken but will be disconnected with the ability to connect it at a later point in time.`,
                confirmLabel: 'Reset',
                denyLabel: 'Cancel',
                confirmAction: () => (0, actionHelpers_1.bindPromiseAction)(dispatch, actions_2.qcsInstitutionLoginAction)({ qcsAction: 'disconnect', id: institutionLogin.id, params: { doSynchrounous: true } })
                    .then(() => dispatch((0, actions_1.doUpdateFi)({ institutionLogin }))),
            })),
        })));
    }, [handleCloseMenu, dispatch, institutionLogin]);
    const kickoffCloseFi = (0, react_1.useCallback)(() => {
        handleCloseMenu();
        dispatch(root_ui_1.rootUiActions.createDialog(root_ui_1.rootUiTypes.mkRootUiData({
            id: 'close-institution',
            type: ConfirmationDialog_1.DIALOG_TYPE,
            allowNesting: true,
            props: (0, immutable_1.Map)((0, ConfirmationDialog_1.mkConfirmationDialogProps)({
                title: 'Close institution',
                content: `Closing ${institutionLogin.name} will set the account balances to $0 and disable downloading of future transactions in Quicken. You will still be able to access all of your old transactions`,
                confirmLabel: 'Confirm',
                denyLabel: 'Cancel',
                confirmAction: () => (0, actionHelpers_1.bindPromiseAction)(dispatch, actions_2.qcsInstitutionLoginAction)({ qcsAction: 'close', id: institutionLogin.id }),
            })),
        })));
    }, [handleCloseMenu, institutionLogin, dispatch]);
    const kickoffDeleteFi = (0, react_1.useCallback)(() => {
        handleCloseMenu();
        dispatch(root_ui_1.rootUiActions.createDialog(root_ui_1.rootUiTypes.mkRootUiData({
            id: 'delete-institution',
            type: ConfirmationDialog_1.DIALOG_TYPE,
            allowNesting: true,
            props: (0, immutable_1.Map)((0, ConfirmationDialog_1.mkConfirmationDialogProps)({
                title: 'Delete institution',
                content: `Deleting ${institutionLogin.name} will remove all of its data and transactions from Quicken. This will not fix connection issues.`,
                confirmLabel: 'Delete',
                confirmButtonVariant: QButton_1.QButtonVariantEnum.DELETE,
                denyLabel: 'Cancel',
                confirmAction: () => dispatch((0, actions_2.deleteInstitutionLogin)(institutionLogin)),
            })),
        })));
    }, [handleCloseMenu, dispatch, institutionLogin]);
    const kickoffAggAction = (0, react_1.useCallback)(() => {
        var _a;
        const institutionId = ((_a = institutionLogin === null || institutionLogin === void 0 ? void 0 : institutionLogin.institution) === null || _a === void 0 ? void 0 : _a.id) || '0';
        core_1.tracker.track(core_1.tracker.events.fiLoginFixItFlowStart, {
            type: aggAction.type,
            id: aggAction.id,
            institution_id: institutionId,
            agg_status: aggAction.status,
            agg_status_code: aggAction.statusCode || 'null',
            location: 'account settings',
        });
        dispatch(aggAction.action);
    }, [aggAction, dispatch, institutionLogin]);
    const kickoffDisconnectFi = (0, react_1.useCallback)(() => {
        handleCloseMenu();
        (0, actionHelpers_1.bindPromiseAction)(dispatch, actions_2.qcsInstitutionLoginAction)({ qcsAction: 'disconnect', id: institutionLogin.id });
    }, [handleCloseMenu, dispatch, institutionLogin]);
    const kickoffConnectFi = (0, react_1.useCallback)(() => {
        handleCloseMenu();
        dispatch((0, actions_1.doUpdateFi)({ institutionLogin }));
    }, [dispatch, handleCloseMenu, institutionLogin]);
    const kickoffRediscoverFi = (0, react_1.useCallback)(() => {
        handleCloseMenu();
        dispatch((0, actions_1.doAccountRediscovery)(institutionLogin));
    }, [handleCloseMenu, dispatch, institutionLogin]);
    // ====================================== Memoized Values ================================================ //
    const institutionLogo = (0, react_1.useMemo)(() => {
        var _a;
        const isPlaidLogo = (_a = institutionLogin === null || institutionLogin === void 0 ? void 0 : institutionLogin.channel) === null || _a === void 0 ? void 0 : _a.includes('PLAID');
        const imgSrc = isPlaidLogo ? ((branding === null || branding === void 0 ? void 0 : branding.logo) && `data:image/svg;base64, ${branding === null || branding === void 0 ? void 0 : branding.logo}`) : branding === null || branding === void 0 ? void 0 : branding.logoUrl;
        return (<img alt="institution logo" src={imgSrc !== null && imgSrc !== void 0 ? imgSrc : accounts_svg_1.default} className={cx(classes.logo, (isPlaidLogo && (branding === null || branding === void 0 ? void 0 : branding.logo)) && classes.plaidLogo)}/>);
    }, [institutionLogin, branding, classes.logo, classes.plaidLogo, cx]);
    const menuOptions = (0, react_1.useMemo)(() => {
        const retOptions = [];
        const addFiEnabled = featureFlags.get('addFi') && isWebFirstDataset && isCurrentDatasetOwner;
        if (addFiEnabled && !loginHasConnectedAccounts && !(accounts === null || accounts === void 0 ? void 0 : accounts.every((acc) => acc.isClosed))) {
            retOptions.push({ label: 'Connect', onSelect: kickoffConnectFi, id: 'login-connect', startIcon: <Explore_1.default /> });
        }
        if (addFiEnabled && showExpandedMenu && loginHasConnectedAccounts) {
            retOptions.push({ label: 'Rediscover', onSelect: kickoffRediscoverFi, id: 'login-rediscover', startIcon: <FindReplace_1.default /> });
        }
        if (addFiEnabled && loginHasConnectedAccounts) {
            retOptions.push({ label: 'Reset connection', onSelect: kickoffResetFi, id: 'login-reset', startIcon: <Refresh_1.default /> });
            if (featureFlags.get('closeAccount'))
                retOptions.push({ label: 'Mark as closed', onSelect: kickoffCloseFi, id: 'login-close', divider: true, startIcon: <CancelPresentation_1.default /> });
        }
        if (addFiEnabled && showExpandedMenu && loginHasConnectedAccounts) {
            retOptions.push({ label: 'Disconnect institution', onSelect: kickoffDisconnectFi, id: 'login-disconnect', startIcon: <ExploreOff_1.default /> });
        }
        retOptions.push({
            customRender: (<Typography_1.default variant={'body1'} sx={{ color: theme.palette.number.negative, display: 'flex', alignItems: 'center' }}>
          <Delete_1.default style={{ marginRight: theme.spacing(1) }}/>
          Delete institution
        </Typography_1.default>),
            onSelect: kickoffDeleteFi,
            id: 'login-delete',
        });
        return retOptions;
    }, [accounts, featureFlags, loginHasConnectedAccounts, theme, kickoffConnectFi, kickoffRediscoverFi, kickoffCloseFi, showExpandedMenu, kickoffDeleteFi, kickoffDisconnectFi, kickoffResetFi, isWebFirstDataset, isCurrentDatasetOwner]);
    const updatedInstitutionNameErrorMessage = (0, react_1.useMemo)(() => {
        if (updatedInstitutionName === null || !institutionLogin)
            return null;
        if (updatedInstitutionName.length === 0)
            return 'New name must be more than 0 characters';
        if (updatedInstitutionName === (institutionLogin === null || institutionLogin === void 0 ? void 0 : institutionLogin.name) || updatedInstitutionName === title)
            return 'New name must be different from current name';
        return null;
    }, [updatedInstitutionName, institutionLogin, title]);
    const errorDisplay = (0, react_1.useMemo)(() => {
        // Not all errors (aggStatus) returned from QCS should kick off fix it flow
        const isReportableError = aggAction && (0, utils_1.isErrorType)(aggAction.status);
        return isReportableError && (<div className={classes.errorContainer}>
        <div className={classes.errorTextContainer}>
          <Typography_1.default variant={'subtitle2'} display={'block'}>
            {aggAction.title}
          </Typography_1.default>
          <Typography_1.default paragraph variant="caption">
            {aggAction.text}
          </Typography_1.default>
          {(aggAction.statusCode || aggAction.code) &&
                <Typography_1.default display={'block'} variant={'caption'}>
              {` Care Code: ${aggAction.statusCode || aggAction.code}`}
            </Typography_1.default>}
        </div>
        {aggAction.action &&
                (aggLoading
                    ? <CircularProgress_1.default size={32} className={classes.errorSpinner}/>
                    :
                        <QButton_1.default id={'accounts-fix-account-button'} variant={'contained'} className={classes.errorActionButton} onClick={kickoffAggAction}>
              {aggAction.actionLabel}
            </QButton_1.default>)}
      </div>);
    }, [aggAction, aggLoading, classes, kickoffAggAction]);
    return (<div className={classes.rootContainer} id={id}>
      <RendersCount_1.default id={`accountCard-${id}`}/>
      {/* ============================================ Header ============================================ */}
      <div className={classes.headerContainer}>
        <Dump_1.default obj={institutionLogin}/>
        <div className={classes.headerTitleContainer}>
          {institutionLogo}
          <Typography_1.default id={`${id}-title`} variant={'h5'} sx={{ whiteSpace: 'nowrap' }}>
            {(institutionLogin === null || institutionLogin === void 0 ? void 0 : institutionLogin.name) || title}
          </Typography_1.default>
        </div>
        {institutionLogin &&
            <IconButton_1.default id={'login-menu-button'} aria-label={'Login Menu'} className={classes.loginMenuIcon} onClick={handleOpenMenu} size="large">
            <MoreVert_1.default />
          </IconButton_1.default>}
      </div>
      <NestedQMenu_1.default id={'login-menu'} anchorEl={menuAnchorEl} open={Boolean(menuAnchorEl)} onClose={handleCloseMenu} options={menuOptions}/>

      {/* ============================================ Content ============================================ */}
      <div className={classes.contentContainer}>
        {errorDisplay}
        {featureFlags.get('a2A') &&
            <Grid_1.default container className={classes.columnHeadersContainer}>
              <Grid_1.default item xs={5}>&nbsp;</Grid_1.default>
              <Grid_1.default item xs={3}>Transactions</Grid_1.default>
              <Grid_1.default item xs={3}>Transfers</Grid_1.default>
              <Grid_1.default item xs={1}>&nbsp;</Grid_1.default>
            </Grid_1.default>}
        <Grid_1.default container>
          <List_1.default className={classes.flexOne}>
            {accounts.map((account, index) => (<AccountListItem_1.default key={account.clientId || account.id} account={account} institutionLogin={institutionLogin} index={index}/>))}
          </List_1.default>
        </Grid_1.default>
      </div>

      {/* ========================================== Edit Dialog ========================================== */}
      <StdDialog_1.default title={'Edit institution'} fullWidth maxWidth="xs" open={showEditDialog} onClose={toggleShowEditDialog} showCloseButton>
        <DialogContent_1.default className={classes.dialogContent}>
          {institutionLogo}
          <div style={{ marginLeft: 10, flexGrow: 1 }}>
            <TextField_1.default id={'institution-name'} label={'Name'} sx={{ width: '100%' }} variant={'outlined'} error={Boolean(updatedInstitutionNameErrorMessage)} defaultValue={(institutionLogin === null || institutionLogin === void 0 ? void 0 : institutionLogin.name) || title} onChange={(e) => setUpdatedInstitutionName(e.target.value)} helperText={updatedInstitutionNameErrorMessage}/>
          </div>
        </DialogContent_1.default>
        <DialogActions_1.default>
          <QButton_1.default id={'cancel-institution'} variant={'outlined'} onClick={toggleShowEditDialog}>Cancel</QButton_1.default>
          <QButton_1.default id={'update-institution'} variant={'contained'} disabled={Boolean(!updatedInstitutionName || updatedInstitutionNameErrorMessage)} onClick={handleUpdateInstitutionName}>
            Update
          </QButton_1.default>
        </DialogActions_1.default>
      </StdDialog_1.default>
    </div>);
};
AccountCardHook.propTypes = {
    institutionLogin: prop_types_1.default.object,
    id: prop_types_1.default.string,
    branding: prop_types_1.default.object,
    title: prop_types_1.default.string,
    accounts: prop_types_1.default.object,
    isWebFirstDataset: prop_types_1.default.bool,
};
exports.default = AccountCardHook;
